import { type FC, useRef } from 'react';
import { VisibilityTracker } from 'dibs-visibility-tracker/src/VisibilityTracker.tsx';
import { useStickyHeaderContext } from './PdpRespMarketplaceStickyHeaderContext.tsx';

export const PdpRespMarketplaceStickyHeaderSwitch: FC = () => {
    const stickyHeaderRef = useRef<HTMLDivElement>(null);
    const { setShowStickyHeader } = useStickyHeaderContext();
    return (
        <>
            <div ref={stickyHeaderRef} />
            <VisibilityTracker
                watchAfterFirstVisible
                elementRef={stickyHeaderRef}
                onVisibilityChange={({ isVisible }) => setShowStickyHeader(!isVisible)}
            />
        </>
    );
};
